import axios from 'axios';

const BASE_URL =
  'https://uqofvhxtyj.execute-api.us-east-1.amazonaws.com/dev/send-tr-message';

export default async ({ name, phone, email, message }) => {
  await axios.post(`${BASE_URL}`, { name, phone, email, message });
};
